module.exports = __webpack_public_path__ + "static/img/zhzx_yellow.c34da942.svg";